import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VoucherType } from '../../../services/voucher.service';

export interface PriceSummaryDialogData {
    quoteId: string;
    totalGross: number;
    totalAdvantage: number;
    totalPrice: number;
    netPrice: number;
    extraBonus: number;
    voucherCode: string;
    voucherType: string;
    voucherValue: number;
    currency: string;
    noPriceAdvantage: boolean;
}

@Component({
    selector: 'app-price-summary-dialog',
    templateUrl: './price-summary-dialog.component.html',
    styleUrls: ['./price-summary-dialog.component.scss'],
})
export class PriceSummaryDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: PriceSummaryDialogData) {}

    public get isKamVoucher() {
        return this.data?.voucherType === VoucherType.kam;
    }

    public get voucherTypeKey() {
        return this.isKamVoucher ? VoucherType.kam : 'DEFAULT';
    }
}
